

















import {Component, Mixins, Vue} from 'vue-property-decorator'
import Documents from '@/modules/shipments/views/detail/components/Documents.vue'
import ConsignmentService from "@/modules/shipments/services/ConsignmentService";
import ECMR from '@/modules/shipments/views/detail/components/ECMR.vue'

@Component({
  components: {
    Documents,
    ECMR
  }
})
export default class ScanDocuments extends Mixins(ConsignmentService) {
  created() {
    this.$store.commit('isOnConsignment', true)
    if (this.$route.params.consignment) {
      this.getConsignment(this.$route.params.consignment)
    }
  }
}
